// Components
import GuestNavbar from "../../Components/Guest/Components/GuestNavbar";

// Icons
import { SignIn, ArrowRight } from "phosphor-react";

// Other
import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";

// Custom hooks
import useLogIn from "../../Hooks/Authentication/useLogIn";

const Login = () => {
  const { logInWithPassword, errorMessage } = useLogIn();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  function handleChange(event) {
    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [event.target.name]: event.target.value,
      };
    });
  }

  const handleLogIn = async (event) => {
    event.preventDefault();

    const email = formData.email;
    const password = formData.password;

    await logInWithPassword(email, password);
  };

  return (
    <>
      <GuestNavbar />
      <section className="font-brand w-80 flex flex-col justify-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        {/* Header */}
        <section className="flex justify-between items-center">
          {/* Title */}
          <h1 className="flex items-center text-xl font-semibold">
            <SignIn size={25} color="#009fff" weight="bold" />
            <span className="ml-2">Log in</span>
          </h1>

          {/* Log in */}
          <span className="text-text-dark-500">
            <Link to="/signup" className="underline font-medium">
              Sign up
            </Link>
            <span> instead.</span>
          </span>
        </section>

        {errorMessage && (
          <span className="text-red-600 text-sm mt-2">{errorMessage}</span>
        )}

        {/* Sign up form */}
        <form onSubmit={handleLogIn} className="mt-5 space-y-3 > * + *">
          {/* Email */}
          <section>
            <label
              htmlFor="email-address"
              className="block font-medium text-text-dark-500"
            >
              Email Address
            </label>
            <div className="relative mt-1 rounded-md shadow-sm">
              <input
                type="email"
                name="email"
                id="email"
                className="block w-full rounded-md pl-3 pr-12 sm:text-sm h-10 bg-dark-500 placeholder-text-dark-500"
                placeholder="you@example.com"
                onChange={handleChange}
                required
                autoComplete=""
              />
            </div>
          </section>

          {/* Password */}
          <section>
            <label
              htmlFor="password"
              className="block font-medium text-text-dark-500"
            >
              Password
            </label>
            <div className="relative mt-1 rounded-md shadow-sm">
              <input
                type="password"
                name="password"
                id="password"
                className="block w-full rounded-md pl-3 pr-12 sm:text-sm h-10 bg-dark-500 placeholder-text-dark-500"
                placeholder="Password..."
                onChange={handleChange}
                required
                autoComplete=""
              />
            </div>
          </section>

          {/* Checkbox Stay Signed in */}
          <section className="form-check">
            <input
              className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-brand-500 checked:border-brand-500 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
              type="checkbox"
              value=""
              id="terms"
            />
            <label
              className="form-check-label flex text-text-dark-500"
              htmlFor="terms"
            >
              <span>Stay signed in</span>
            </label>
          </section>

          {/* Submit Button */}
          <button className="flex py-1.5 px-4 rounded text-white bg-brand-500 hover:bg-brand-700 cursor-pointer">
            <span>Log in</span>
            <ArrowRight size={25} color="#fff" weight="bold" className="ml-1" />
          </button>
        </form>
      </section>
    </>
  );
};

export default Login;
